import React, { Component } from 'react'

class Service extends Component {
  constructor(props) {
    super(props)

    this.state = { serviceContent: '', intervalId: false }
  }

  componentDidMount() {
    this.setState({
      serviceContent: this.props.typeOut ? '' : this.props.title
    })

    if(this.state.serviceContent == '') {
      this.setState({
        intervalId: setInterval(this.autoType.bind(this), Math.floor(Math.random() * (1000 - 100)) + 100)
      })
    }
  }

  autoType() {
    const currentServiceContent = this.state.serviceContent.replace('|', '')
    if (currentServiceContent.length == this.props.title.length) {
      clearInterval(this.state.intervalId)
    } else {
      const nextLetter = this.props.title[currentServiceContent.length]
      const carat = (currentServiceContent.length + 1 != this.props.title.length) ? '|' : ''

      this.setState({
        serviceContent: `${currentServiceContent}${nextLetter}${carat}`
      })
    }
  }

  render() {
    return (
      <span title={this.props.title} className={'service ' + this.props.className}>
        { this.state.serviceContent }
      </span>
    )
  }
}

export default Service



// WEBPACK FOOTER //
// ./src/components/Service/index.js